import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { modifyPageLayoutComponents } from '../PageLayout';
import * as actions from './../../actions';
import { showChooseEmailTemplatesPopup } from '../../actions/A_Popups';

import template from '../../templates/EmailTemplates/EmailTemplates.rt';
import EmailTemplatesHeaderTemplate from '../../templates/EmailTemplates/EmailTemplatesHeader.rt';


const mapStateToProps = state => ({
  // searchKeyword: state.sites.searchKeyword
  // emailTemplates: state.sites.data.rows,
  // page: state.sites.data.page,
  // totalPages: state.sites.data.totalPages,
  // statusUpdateSuccess: state.sites.statusUpdateSuccess
  //userRoles: state.auth.roles
});

const mapDispatchToProps = dispatch => ({
  // getSites: (page, limit, searchKeyword, sortKeyword) => dispatch(getSites(page, limit, searchKeyword, sortKeyword)),
  // updateSite: (site) => dispatch(updateSite(site)),
  // setSearchTerm: (value) => dispatch(getSites(0, 50, value)),
  showChooseEmailTemplatesPopup: show => dispatch(showChooseEmailTemplatesPopup(show)),
  go: where => dispatch(actions.changeLocation(where)),
  logout: () => dispatch(actions.logout())
});

class EmailTemplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEmailTemplatesPopup: false,
      page: 0
    };
  }

  componentWillMount() {
    // this.props.getEmails();
  }

  componentWillReceiveProps(nextProps) {

  }

  chooseEmailTemplate(template) {
    console.log(template);
  }

  handleClosePopup() {
    this.setState({
      showEmailTemplatesPopup: false
    })
  }

  render() {
    return template.apply(this);
  }

}

EmailTemplates.propTypes = {
  // sites: PropTypes.array,
  // page: PropTypes.number,
  // totalPages: PropTypes.number,
  // getSites: PropTypes.func.isRequired,
  // updateSite: PropTypes.func.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const EmailTemplatesLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(EmailTemplatesHeaderTemplate),
  content: connector(EmailTemplates)
});

